import { Box, Image, Portal, Text } from "@chakra-ui/react";

import Logo from "../../assets/gopass-logo.png";

export function Loading() {
  return (
    <Portal>
      <Box
        width={"100vw"}
        minHeight={"100vh"}
        height={'full'}
        zIndex={99999}
        top={0}
        right={0}
        left={0}
        bottom={0}
        position={"absolute"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        bg={"rgba(0,0,0,0.5)"}
      >
        <Box bg={"white"} p={5} margin={"0 auto"} mt={"5"} w={"80"}>
          <Image src={Logo} margin={"0 auto"} className="loader-gopass" />
          <Text
            textAlign={"center"}
            color={"purple.900"}
            fontWeight={"bold"}
            mt={4}
          >
            Carregando
          </Text>
        </Box>
      </Box>
    </Portal>
  );
}
